import React, { useState, useEffect } from "react";
import { transactionAPI } from 'services';
import { Loader } from "components";
import { formatMoney } from "utils";
import DatePicker from "react-datepicker";
import { toast } from "sonner";
import useUniversalStore from "store/universalStore";
import useOffcanvasStore from "store/offcanvasStore";
import { useForm, Controller } from "react-hook-form";
import { defaultValues, formFields } from "./config";

const EditTxn = (props) => {
  const { handleChangeMonth } = props;
  const { transactionId, accountId, write } = useUniversalStore(state => state);
  const { closeOffcanvas } = useOffcanvasStore();
  const { control, handleSubmit, setValue, formState: { errors, isSubmitting, isValid } } = useForm({
    defaultValues,
    mode: 'onChange'
  });


  useEffect(() => {
    fetchTransactionDetails();
  }, []);

  const fetchTransactionDetails = async () => {
    try {
      const transaction = await transactionAPI.getTransactionById(transactionId);
      if (transaction) {
        formFields.forEach(field => {
          setValue(field.name, transaction.get(field.name) || "");
        });
      }
    } catch (error) {
      toast.error("Failed to fetch transaction details");
    }
  };

  const amountChangeHandler = (e, onChange) => {
    e.preventDefault();

    // Extract numeric value from the input
    let numericValue = parseFloat(e.target.value.replace(/[^0-9.-]/g, "")) || 0;

    // Update the form value for amount
    if (numericValue === NaN || numericValue === "") {
      onChange(0);
    }
    onChange(numericValue);
  };

  const onSubmit = async (data) => {

    try {
      //Set time along with date to order transactions
      data.date.setHours(data.date.getHours(),
        data.date.getMinutes(), data.date.getSeconds());

      const updatedTransaction = await transactionAPI.updateTransaction(
        transactionId,
        data.amount,
        data.detail,
        data.date
      );

      //Update selected account data
      //const updatedTransactionDate = new Date(data.date);
      //handleChangeMonth(updatedTransactionDate);

      //Update transactions in global store
      write({
        transactions: await transactionAPI.getTransactionsByAccountIdWithMonth(accountId, data.date),
        transactionId: null
      });

      closeOffcanvas();
      toast.success("Transaction updated successfully");

    } catch (error) {
      toast.error(error.message);
    }
  };


  const renderField = (field, index) => {
    const commonProps = {
      placeholder: field.placeholder,
      className: `form-control ${errors[field.name] ? 'is-invalid' : ''}`
    };
    return (
      <div className={field.name === "amount" || field.name === "date" ? "mb-3 col-6" : "mb-3"}>
        <Controller
          key={index}
          name={field.name}
          control={control}
          rules={field.rules ? {
            ...field.rules,
            validate: field.rules.validate
              ? (value) => field.rules.validate(value, accountId)
              : undefined
          } : {}}
          render={({ field: { value, onChange, ...fieldProps } }) => {
            switch (field.type) {
              case 'date':
                return (
                  <div className="form-control border-0 p-0">
                    <label className="text-app" style={{ fontSize: "0.75rem" }}>{field.name.charAt(0).toUpperCase() + field.name.slice(1)}</label>
                    <DatePicker
                      selected={value}
                      onChange={(dateValue) => onChange(dateValue)}
                      dateFormat="dd-MM-yyyy"
                      maxDate={new Date()}
                      className="form-control"
                      wrapperClassName="w-100"
                    />
                  </div>
                )
              case 'textarea':
                return (
                  <div className="form-control border-0 p-0">
                    <label className="text-app" style={{ fontSize: "0.75rem" }}>{field.name.charAt(0).toUpperCase() + field.name.slice(1)}</label>
                    <textarea
                      {...fieldProps}
                      {...commonProps}
                      value={value}
                      onChange={onChange}
                    />
                  </div>
                )
              case 'creatable':
                return null;
              case 'checkbox':
                return null;
              case 'file':
                return null;
              case 'amount':
                return (
                  <div className="form-control border-0 p-0">
                    <label className="text-app" style={{ fontSize: "0.75rem" }}>{field.name.charAt(0).toUpperCase() + field.name.slice(1)}</label>
                    <input
                      {...fieldProps}
                      {...commonProps}
                      id="editTxnAmountInput"
                      type="text"
                      value={formatMoney(value)}
                      onChange={(e) => amountChangeHandler(e, onChange)}
                    />
                  </div>
                );
              default:
                return (
                  <div className="form-control border-0 p-0">
                    <label className="text-app" style={{ fontSize: "0.75rem" }}>{field.name.charAt(0).toUpperCase() + field.name.slice(1)}</label>
                    <input
                      {...fieldProps}
                      {...commonProps}
                      type={field.type}
                      onChange={onChange}
                    />
                  </div>
                );
            }
          }}
        />
        {errors[field.name] && (
          <div className="invalid-feedback d-block">{errors[field.name].message}</div>
        )}
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row p-0">

      {formFields.map(renderField)}

      <div className="row sticky-bottom-drawer my-3">
        <div className="col-md-12 d-grid">
          <button type="submit"
            className="btn btn-app block py-3 text-uppercase fs-5 fw-bold"
            disabled={isSubmitting || !isValid || errors.amount}
          >
            {isSubmitting ? (
              <span className="spinner-border spinner-border-sm me-2" />
            ) : (
              <b className="">Update</b>
            )}
          </button>
        </div>
      </div>
    </form>
  )
}
export default EditTxn;
